export enum CheckoutPath {
  PAYMENT_RESULT_CALLBACK = 'payment/callback',
}
